import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { NbDialogService } from "@nebular/theme";
import { UserService } from "../../../@core/services/user.service";

import { Router } from "@angular/router";

import Bookmark from "../../../models/bookmark.model";
import { BookmarkService } from "../../../services/bookmark.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { DialogYesNoPromptComponent } from "../../dialog-yesno-prompt/dialog-yesno-prompt.component";

@Component({
  selector: "ngx-view-bookmark",
  styleUrls: ["./view-bookmark.component.scss"],
  templateUrl: "./view-bookmark.component.html",
})
export class ViewBookmarkComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() bookmark: Bookmark;
  @Input() mode?: string = "home"; //home / tutor / detail
  @Input() isMore? = false;
  @Output() onDelete: EventEmitter<any> = new EventEmitter();
  @Output() onEdit: EventEmitter<any> = new EventEmitter();

  loading = false;
  submitted = false;
  view = "question";
  uid = "";

  constructor(
    public userService: UserService,
    private bookmarkService: BookmarkService,
    private router: Router,
    private dialogService: NbDialogService
  ) {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
        } else {
          this.uid = "anonymous";
        }
      });
  }

  ngOnInit() {}

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  navigateRef(item) {
    if (item.navigateUrl && item.navigateUrl.length > 0) {
      this.router.navigateByUrl(item.navigateUrl);
    }
  }

  uncheck(item) {
    if (!this.submitted) {
      this.submitted = true;
      this.dialogService
        .open(DialogYesNoPromptComponent, {
          context: {
            title: "Bạn có chắc xóa mục này?",
          },
        })
        .onClose.subscribe((value) => {
          if (value) {
            this.loading = true;
            this.bookmarkService
              .uncheckBookmark(item)
              .then((result) => {
                this.loading = false;
                this.submitted = false;
                this.onDelete.emit(item.id);
              })
              .catch((err) => {
                this.loading = false;
                this.submitted = false;
              });
          }
          this.submitted = false;
        });
    }
  }
}
